import { Container, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import logo from "../images/ikdki.png";
import { ReactComponent as Logo } from "../images/ikdki.svg";
import ImageField from "./custom/ImageField";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CustomTextField from "./custom/CustomTextField";
import { isEmailValid } from "../utils/ValidationRules";
import CustomButton from "./custom/CustomButton";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../utils/swalToast";
import { Link } from "react-router-dom";

const ResetPassword = () => {
  const [email, setEmail] = useState("");

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const linkStyle = {
    fontWeight: "bold",
    textDecoration: "none",
    color: "#003158",
    marginLeft: "5px",
    "&:hover": {
      color: "#00213A",
    },
  };

  const sendEmailResetPassword = async (e) => {
    e.preventDefault();
    try {
      const sendEmailResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_HOST}/send-mail-reset-password`,
        {
          email,
        }
      );
      showSuccessToast(sendEmailResponse.data.msg);
    } catch (err) {
      if (err.response) {
        showErrorToast(err.response.data.msg);
      }
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#f0ebeb",
        minHeight: "100vh",
        maxHeight: "100000vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="md">
        <Grid
          container
          fullWidth
          sx={{
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            item
            md={12}
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Logo
              style={{
                width: isSmallScreen ? "55%" : "40%",
                height: isSmallScreen ? "55%" : "40%",
              }}
            />
          </Grid>
          <Grid container spacing={2} sx={{ textAlign: "center" }}>
            <Grid item md={12} xs={12}>
              <CustomTextField
                isFullWidth={false}
                placeholder="Masukkan email anda"
                icon={<AccountCircleIcon sx={{ color: "black" }} />}
                iconLabel="Email"
                iconWidth={true}
                autoComplete="email"
                width={"90%"}
                type="email"
                value={email}
                rule={isEmailValid}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <CustomButton
                text="Send Email"
                baseColor="#003158"
                hoverColor="#00213A"
                isFullWidth={false}
                width={"90%"}
                onClick={sendEmailResetPassword}
              />
            </Grid>
            <Grid item md={12} xs={12}>
              <Typography sx={{ color: "black", fontSize: { xs: "0.8rem", sm: "1rem" } }}>
                <Link to="/" style={linkStyle}>
                  kembali ke halaman login
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default ResetPassword;
